import { render, staticRenderFns } from "./demandContactsCheck.vue?vue&type=template&id=513d7361&scoped=true&"
import script from "./demandContactsCheck.vue?vue&type=script&lang=js&"
export * from "./demandContactsCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513d7361",
  null
  
)

export default component.exports